import { YStack } from '@holo/ui';
import Footer from '@/components/Footer';
import dynamic from 'next/dynamic';
import Drawers from '@/components/Drawers';
import Modals from '@/components/Modals';

const MobileHeader = dynamic(() => import('@/components/Header/HeaderMobile'));
const DesktopHeader = dynamic(() => import('@/components/Header/HeaderDesktop'));

type Props = {
  children: React.ReactNode;
};

const Layout = ({ children }: Props) => {
  return (
    <YStack minHeight="100vh">
      <Drawers />
      <Modals />
      <MobileHeader />
      <DesktopHeader />
      <YStack flex={1} tag="main" mb="$20">
        {children}
      </YStack>
      <Footer />
    </YStack>
  );
};

export default Layout;
